var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationXButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_881_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C8.09625 27.5 2.5 21.9038 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9038 2.5 27.5 8.09625 27.5 15C27.5 21.9038 21.9038 27.5 15 27.5ZM15 13.2325L11.465 9.69625L9.69625 11.465L13.2325 15L9.69625 18.535L11.465 20.3038L15 16.7675L18.535 20.3038L20.3038 18.535L16.7675 15L20.3038 11.465L18.535 9.69625L15 13.2325Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_881_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationXButton);
export default __webpack_public_path__ + "static/media/InformationXButton.60b01464be56ef854f5b8784e4d5a971.svg";
export { ForwardRef as ReactComponent };